import React from "react";
import { Link } from "react-router-dom";
import { GLOSSARY } from "@/content/articles";
import { ArrowLeft, Library } from "lucide-react";

export default function Glossary() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-12 lg:px-8" data-testid="glossary-page">
      <div className="mb-6 flex justify-start">
        <Link to="/guide" data-testid="back-guides-link" className="group inline-flex items-center gap-2 rounded-full border-2 border-emerald-500 bg-emerald-50 px-5 py-2.5 text-sm font-bold text-emerald-700 shadow-sm transition-all hover:bg-emerald-500 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Guide e Tutorial
        </Link>
      </div>
      <div className="mb-10 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-600"><Library className="h-7 w-7" /></div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Glossario PDF</h1>
        <p className="mx-auto mt-3 max-w-2xl text-slate-500">I termini tecnici del mondo dei documenti digitali — OCR, DPI, raster, metadata e altri — spiegati in modo chiaro e pratico.</p>
      </div>
      <div className="space-y-4">
        {GLOSSARY.map((g, i) => (
          <article key={i} data-testid={`glossary-item-${i}`} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <h2 className="font-display text-lg font-bold text-slate-900">{g.term}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{g.def}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
